import webPic02 from '../assests/web pic-02.jpg';
import webPic03 from '../assests/web pic-03.jpg';
import webPic04 from '../assests/web pic-04.jpg';
import webPic17 from '../assests/web pic-17.jpg';
import webPic05 from '../assests/web pic-05.jpg';
import webPic06 from '../assests/web pic-06.jpg';
import webPic07 from '../assests/web pic-07.jpg';
import webPic08 from '../assests/web pic-08.jpg';
import webPic09 from '../assests/web pic-09.jpg';
import webPic10 from '../assests/web pic-10.jpg';
import webPic11 from '../assests/web pic-11.jpg';
import webPic12 from '../assests/web pic-12.jpg';
import webPic13 from '../assests/web pic-13.jpg';
import webPic14 from '../assests/web pic-14.jpg';
import webPic15 from '../assests/web pic-15.jpg';
import webPic16 from '../assests/web pic-16.jpg';

export const ServicPageListAR = [
  {
    id: 1,
    title: 'تطبيقات الجوال', // تم تصحيح تتطبيقات إلى تطبيقات
    slug: 'mobile-applications', // 🚨 تم إضافة Slug
    img: webPic02,
    small_description: 'تطبيقات جوال مبتكرة تلبي احتياجات عملك وتوفر تجربة مستخدم استثنائية على iOS وAndroid',
    description: 'نطور تطبيقات جوال ذكية باستخدام أحدث التقنيات مثل Flutter وReact Native، مع تركيز على الوظائف المخصصة والأداء العالي. نضمن توافقًا كاملًا مع متطلبات المتاجر الرقمية (App Store & Google Play)، ونتائج متميزة في اختبارات الأداء والأمان',
  },
  {
    id: 2,
    title: 'مواقع إلكترونية',
    slug: 'websites', // 🚨 تم إضافة Slug
    img: webPic03,
    small_description: 'تصميم مواقع سريعة، آمنة، ومُحسنة لمحركات البحث لتعزيز حضورك الرقمي.',
    description: 'مواقع بتصميم متجاوب يعمل على جميع الأجهزة، مدعومة بخوادم سحابية، مع تطبيق أفضل ممارسات الـ SEO. نقدم حلولًا من المتاجر الإلكترونية (eCommerce) إلى المنصات المعقدة باستخدام WordPress, Laravel, وغيرها.',
  },
  {
    id: 3,
    title: 'انظمة محاسبية',
    slug: 'accounting-system', // 🚨 تم إضافة Slug
    img: webPic04,
    small_description: 'حلول محاسبية ذكية تُبسط عملياتك المالية وتوفر تقارير دقيقة في الوقت الفعلي',
    description: 'أنظمة متكاملة لإدارة الفواتير، المصروفات، الرواتب، والضرائب. تتكامل مع البنوك وتوفر تحليلات مالية تفصيلية لمساعدتك في اتخاذ القرارات',
  },
  {
    id: 4,
    title: 'نظام ERP',
    slug: 'erp-system', // 🚨 تم إضافة Slug
    img: webPic17,
    small_description: 'دمج جميع أقسام شركتك في نظام واحد لتحقيق الكفاءة والشفافية المالية',
    description: 'حلول ERP مخصصة تشمل (المخازن، الموارد البشرية، المبيعات، التصنيع) مع لوحات تحكم تفاعلية وتقارير قابلة للتخصيص.',
  },
  {
    id: 5,
    title: 'تطبيقات سطح المكتب',
    slug: 'desktop-applications', // 🚨 تم إضافة Slug
    img: webPic05,
    small_description: 'برامج سطح مكتب آمنة وسهلة الاستخدام لتحسين إنتاجية فريقك.',
    description: 'تطبيقات تعمل على Windows, macOS, Linux بخصائص مثل المزامنة السحابية، واجهات قابلة للتخصيص، ودعم متعدد اللغات.',
  },
  {
    id: 6,
    title: 'اختبار الجودة',
    slug: 'quality-testing', // 🚨 تم إضافة Slug
    img: webPic06,
    small_description: 'ضمان خلو منتجاتك الرقمية من الأخطاء بأدوات اختبار متقدمة.',
    description: 'اختبار وظيفي، أداء، أمان، وتوافق مع جميع الأجهزة باستخدام احدث التقنيات',
  },
  {
    id: 7,
    title: 'الصيانة والدعم',
    slug: 'maintenance-and-support', // 🚨 تم إضافة Slug
    img: webPic07,
    small_description: 'دعم فني متاح 24/7 مع تحديثات دورية لضمان استقرار أنظمتك',
    description: 'حزم صيانة تشمل: مراقبة الأداء، إصلاح الأعطال الطارئة، نسخ احتياطية، وتحديثات أمنية',
  },
  {
    id: 8,
    title: 'إنتاج الحملات الإعلانية',
    slug: 'advertising-campaign-production', // 🚨 تم إضافة Slug
    img: webPic08,
    small_description: 'حملات إعلانية مبدعة على Google, YouTube, Instagram لتعزيز مبيعاتك.',
    description: 'تصميم إعلانات جذابة، استهداف دقيق للجمهور، وتحليل النتائج لتحقيق أعلى عائد استثمار (ROI).',
  },
  {
    id: 9,
    title: 'تحسين محركات البحث SEO',
    slug: 'search-engine-optimization-seo', // 🚨 تم إضافة Slug
    img: webPic09,
    small_description: 'تصدر نتائج البحث بخطط SEO مدروسة تعزز حركة الزوار العضوية',
    description: 'تحليل الكلمات المفتاحية، تحسين المحتوى، بناء الروابط الخلفية (Backlinks)، وتحسين سرعة الموقع.',
  },
  {
    id: 10,
    title: 'إدارة منصات التواصل الإجتماعي',
    slug: 'social-media-management', // 🚨 تم إضافة Slug
    img: webPic10,
    small_description: 'إدارة احترافية لحساباتك على انستغرام تيك توك تويتر فيسبوك لزيادة تفاعل الجمهور',
    description: 'إنشاء محتوى منتظم، جدولة المنشورات، تفاعل مع المتابعين، وتحليل أداء الحملات',
  },
  {
    id: 11,
    title: 'حملات البريد الإلكتروني',
    slug: 'email-campaigns', // 🚨 تم إضافة Slug
    img: webPic11,
    small_description: 'تصميم حملات بريدية فعالة لتحويل العملاء المحتملين إلى مشترين.',
    description: 'تصميم قوالب جذابة، تقسيم القوائم البريدية، اختبار A/B، وتتبع معدلات الفتح والنقر.',
  },
  {
    id: 12,
    title: 'إنشاء محتوى إبداعي',
    slug: 'creative-content-creation', // 🚨 تم إضافة Slug
    img: webPic12,
    small_description: 'محتوى مكتوب ومرئي يجذب انتباه جمهورك ويعزز الثقة بينكم.',
    description: 'نصوص إعلانية، فيديوهات موشن جرافيك، إنفوجرافيك، وصور احترافية بمعايير السيو',
  },
  {
    id: 13,
    title: 'تصوير المنتجات',
    slug: 'product-photography', // 🚨 تم إضافة Slug
    img: webPic13,
    small_description: 'صور منتجات احترافية تُبرز تفاصيل سلعتك وتزيد المبيعات',
    description: 'تصوير بإضاءة احترافية، تعديل الصور (ريتوش)، وإنزال الخلفيات (Background Removal)',
  },
  {
    id: 14,
    title: 'تصميم الشعار',
    slug: 'logo-design', // 🚨 تم إضافة Slug
    img: webPic14,
    small_description: 'شعار مميز يختزل هوية علامتك التجارية في تصميم مبتكر',
    description: 'تصميم شعارات متعددة الاستخدامات (Vector) مع دليل استخدام الألوان والخطوط.',
  },
  {
    id: 15,
    title: 'التغطيات الإعلامية',
    slug: 'media-coverage', // 🚨 تم إضافة Slug
    img: webPic15,
    small_description: 'توثيق الحدث الإعلامي أو الشخصي بدقة وجودة متكاملة',
    description: 'كتابة البيانات الصحفية، التنسيق مع الإعلاميين، ونشر التقارير في قنوات متخصصة',
  },
  {
    id: 16,
    title: 'تصميم هوية بصرية',
    slug: 'visual-identity-design', // 🚨 تم إضافة Slug (متطابق مع الرابط الذي جربته)
    img: webPic16,
    small_description: 'هوية بصرية متكاملة تُعبر عن قيم علامتك وتجذب عملاءك',
    description: 'دليل هوية يشمل: الشعار، الألوان، الخطوط، وأسلوب التصميم لضمان الاتساق.',
  },
];

export const ServicPageListEN = [
  {
    id: 1,
    title: 'Mobile Applications',
    slug: 'mobile-applications', // 🚨 تم إضافة Slug
    img: webPic02,
    small_description: 'Innovative mobile apps tailored to your business needs, delivering exceptional UX on iOS & Android.',
    description: 'We build smart mobile apps using Flutter & React Native, with custom features and high performance. Full compliance with App Store & Google Play guidelines, rigorous performance/security testing',
  },
  {
    id: 2,
    title: 'Websites',
    slug: 'websites', // 🚨 تم إضافة Slug
    img: webPic03,
    small_description: 'Fast, secure, SEO-optimized websites to elevate your digital presence',
    description: 'Fully responsive designs, cloud hosting, and SEO best practices. From eCommerce to complex platforms using WordPress, Laravel, and more.',
  },
  {
    id: 3,
    title: 'Accounting System',
    slug: 'accounting-system', // 🚨 تم إضافة Slug
    img: webPic04,
    small_description: 'Smart accounting solutions to streamline finances with real-time reporting',
    description: 'Integrated systems for invoices, expenses, payroll, and taxes. Bank-compatible with detailed financial analytics.',
  },
  {
    id: 4,
    title: 'ERP System',
    slug: 'erp-system', // 🚨 تم إضافة Slug
    img: webPic17,
    small_description: 'Unify your business departments into one system for efficiency & transparency.',
    description: 'Custom ERP solutions for inventory, HR, sales, manufacturing, with interactive dashboards.',
  },
  {
    id: 5,
    title: 'Desktop Applications',
    slug: 'desktop-applications', // 🚨 تم إضافة Slug
    img: webPic05,
    small_description: 'Secure, user-friendly desktop apps to boost team productivity.',
    description: 'Windows/macOS/Linux apps with cloud sync, customizable UI, and multilingual support',
  },
  {
    id: 6,
    title: 'Quality Testing',
    slug: 'quality-testing', // 🚨 تم إضافة Slug
    img: webPic06,
    small_description: 'Bug-free digital products with advanced testing tools',
    description: 'Functional, performance, security, and cross-device testing using Selenium, JMeter, etc',
  },
  {
    id: 7,
    title: 'Maintenance and Support',
    slug: 'maintenance-and-support', // 🚨 تم إضافة Slug
    img: webPic07,
    small_description: '24/7 technical support with regular updates for system stability',
    description: 'Performance monitoring, emergency fixes, backups, and security patches',
  },
  {
    id: 8,
    title: 'Advertising Campaign Production',
    slug: 'advertising-campaign-production', // 🚨 تم إضافة Slug
    img: webPic08,
    small_description: 'Creative ad campaigns on Google & social media to boost sales',
    description: 'Eye-catching ads, precise audience targeting, and ROI-driven analytics.',
  },
  {
    id: 9,
    title: 'Search Engine Optimization (SEO)',
    slug: 'search-engine-optimization-seo', // 🚨 تم إضافة Slug
    img: webPic09,
    small_description: 'Rank higher with strategic SEO plans for organic traffic growth',
    description: 'Keyword research, content optimization, backlink building, and site speed enhancement.',
  },
  {
    id: 10,
    title: 'Social Media Management',
    slug: 'social-media-management', // 🚨 تم إضافة Slug
    img: webPic10,
    small_description: 'Professional Instagram, TikTok, Twitter, Facebook management to boost engagement',
    description: 'Content creation, post scheduling, audience interaction, and campaign analytics',
  },
  {
    id: 11,
    title: 'Email Campaigns',
    slug: 'email-campaigns', // 🚨 تم إضافة Slug
    img: webPic11,
    small_description: 'Effective email campaigns to convert leads into customers',
    description: 'Custom templates, list segmentation, A/B testing, and open/click tracking.',
  },
  {
    id: 12,
    title: 'Creative Content Creation',
    slug: 'creative-content-creation', // 🚨 تم إضافة Slug
    img: webPic12,
    small_description: 'Engaging written & visual content to amplify your brand identity',
    description: 'Ad copies, motion graphics, infographics, and SEO-friendly visuals',
  },
  {
    id: 13,
    title: 'Product Photography',
    slug: 'product-photography', // 🚨 تم إضافة Slug
    img: webPic13,
    small_description: 'Professional product photos to highlight details and boost sales',
    description: 'Studio lighting, photo retouching, and transparent background removal',
  },
  {
    id: 14,
    title: 'Logo Design',
    slug: 'logo-design', // 🚨 تم إضافة Slug
    img: webPic14,
    small_description: 'A unique logo that encapsulates your brand’s identity',
    description: 'Vector-based logos with brand style guides (colors & fonts)',
  },
  {
    id: 15,
    title: 'Media Coverage',
    slug: 'media-coverage', // 🚨 تم إضافة Slug
    img: webPic15,
    small_description: 'Documenting media or personal events with precise accuracy and comprehensive quality.',
    description: 'Press releases, journalist coordination, and niche media publishing',
  },
  {
    id: 16,
    title: 'Visual Identity Design',
    slug: 'visual-identity-design', // 🚨 تم إضافة Slug
    img: webPic16,
    small_description: 'A cohesive visual identity that reflects your brand values.',
    description: 'Brand book covering: logo, colors, fonts, and design style for consistency',
  },
];
